import React from 'react';
import { groupBy, sumBy } from 'lodash';
import { DocumentStatus, SellerLegalDocsStats, SentTemplateData } from '../../../api';
import { Status } from './Status';

export interface AggregatedStatus {
    label: string;
    status: React.ComponentProps<typeof Status>['type'];
}

export const getAggregatedStatus = (templates: SentTemplateData[]): AggregatedStatus => {
    const total = templates.length || 0;
    const templatesByStatus = groupBy(templates, (document) => document.currentStatus);
    const signed = templatesByStatus[DocumentStatus.SIGNED]?.length || 0;
    const label = `${signed}/${total}`;
    if (signed === total) return { label, status: 'success' };
    if (templatesByStatus[DocumentStatus.EXPIRED]?.length) return { label, status: 'warning' };
    return { label, status: 'info' };
};

export const getAggregatedStatusFromInitialData = (initialData?: SellerLegalDocsStats): AggregatedStatus => {
    const { statuses } = initialData || {};
    const total = sumBy(statuses, (statusStats) => statusStats.count || 0);
    const signed = statuses?.find((stats) => stats.status === DocumentStatus.SIGNED)?.count || 0;
    const expired = statuses?.find((stats) => stats.status === DocumentStatus.EXPIRED)?.count || 0;
    const label = `${signed}/${total}`;
    if (signed === total) return { label, status: 'success' };
    if (expired) return { label, status: 'warning' };
    return { label, status: 'info' };
};
